import * as React from "react";
import { Card, Badge } from "antd";
import Text from "antd/lib/typography/Text";

export interface Props {
  stepNumber: number;
  title: string;
  description: string;
  isEnabled?: boolean;
  children: React.ReactNode;
}

export interface State {}

export default class SignatureStepCard extends React.Component<Props, State> {
  render() {
    const {
      stepNumber,
      title,
      description,
      isEnabled = true,
      children
    } = this.props;

    return (
      <Card
        bordered
        style={{
          opacity: isEnabled ? 1 : 0.5
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 12
          }}
        >
          <Badge
            count={stepNumber}
            style={{
              backgroundColor: "#1890ff"
            }}
          />
          <div>
            <div style={{ fontWeight: 500, fontSize: 14 }}>{title}</div>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {description}
            </Text>
          </div>
        </div>
        {children}
      </Card>
    );
  }
}
